import { SessionKindGroupName } from 'types/models/SessionsPageData';
import { t } from 'utilities/TranslationUtils';

export function kickNoun(kind: SessionKindGroupName | undefined, uppercase = false): string {
  const base = kind === 'ThrowIn' ? t('sessions.kickNounThrowsPlural') : t('sessions.kickNounPlural');
  return uppercase ? base.toUpperCase() : base;
}

/**
 * Corner "on target" percentage for display (0–100), or null for non-Corner kinds
 * or missing data. The snapshot's `onTarget` field may arrive as a 0–1 ratio or an
 * already-scaled 0–100 value; this normalises, clamps to [0,100] and rounds.
 * NOTE: the backend should ideally send an already-scaled value so this guessing
 * can be removed.
 */
export function cornerOnTargetPct(
  kind: SessionKindGroupName | undefined,
  onTarget: number | null | undefined,
): number | null {
  if (kind !== 'Corner' || onTarget === null || onTarget === undefined) return null;
  const ratio = onTarget > 1 ? onTarget / 100 : onTarget;
  return Math.round(Math.max(0, Math.min(1, ratio)) * 100);
}
